module.exports = __webpack_public_path__ + "static/icons/icon-map--japan-78e3e57fefbb765d1e32be343666bc56.svg";